import { render } from "./MainPage.vue?vue&type=template&id=a14ba9fa&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"

import "./MainPage.vue?vue&type=style&index=0&id=a14ba9fa&scoped=true&lang=css"

import exportComponent from "C:\\vue\\erfcRanking\\erfc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a14ba9fa"]])

export default __exports__